import { render, staticRenderFns } from "./ProfileBank.vue?vue&type=template&id=da2aede2&"
import script from "./ProfileBank.vue?vue&type=script&lang=js&"
export * from "./ProfileBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports